export default __webpack_public_path__ + "images/0x8a953cfe442c5e8855cc6c61b1293fa648bae472.png";